'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactIntl = require('react-intl');

var _pacomo = require('utils/pacomo');

var _components2 = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function NativeAppPrompt(props) {
    var mobileAppLink = props.mobileAppLink;

    if (mobileAppLink) {
        return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'formLogin.appPrompt.text',
                defaultMessage: 'Or login to Good to Go using our {mobileApp}.',
                values: {
                    mobileApp: _react2.default.createElement(
                        'a',
                        { href: mobileAppLink, target: '_blank' },
                        'mobile app'
                    )
                }
            })
        );
    }
    return _react2.default.createElement('div', null);
}
var mapStateToProps = function mapStateToProps(state) {
    return {
        mobileAppLink: state.user.mobileAppLink
    };
};
NativeAppPrompt = (0, _reactRedux.connect)(mapStateToProps)((0, _pacomo.pacomoTransformer)(NativeAppPrompt));

function TravellerTag(_ref) {
    var name = _ref.name;

    return _react2.default.createElement(
        'div',
        null,
        name && _react2.default.createElement(
            'h3',
            null,
            _react2.default.createElement('img', { src: require('theme/img/g_logo.svg'), alt: 'Good To Go Trademark', title: 'Good To Go' }),
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'formLogin.title',
                defaultMessage: '{name}',
                values: { name: name } }),
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'formLogin.question',
                defaultMessage: 'Are you Good to Go?'
            })
        ),
        _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'formLogin.authPrompt',
                defaultMessage: 'You\u2019ve purchased your tour, but we need more details\n                                     before you take off. Log in here to manage all your\n                                     pre-departure info. You can begin as soon as your first\n                                     booking has been confirmed.' })
        )
    );
}
TravellerTag = (0, _pacomo.pacomoTransformer)(TravellerTag);

var Login = function Login(props) {
    return _react2.default.createElement(
        _components2.LoadingIndicator,
        {
            mustExist: [{
                value: props.customerId,
                error: 'Could not find `data-customer-id` attribute on "goodtogo" DOM element.'
            }] },
        props.customerId && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(TravellerTag, {
                className: 'TravellerTag',
                name: props.userName
            }),
            _react2.default.createElement(_components2.LoginForm, (0, _extends3.default)({
                className: 'LoginForm'
            }, props)),
            _react2.default.createElement(NativeAppPrompt, null)
        )
    );
};

exports.default = (0, _pacomo.pacomoTransformer)(Login);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/components/Login/Login.js
// module id = 1301
// module chunks = 0